import { render, staticRenderFns } from "./SkuTiempos.vue?vue&type=template&id=47494ea4&scoped=true&"
import script from "./SkuTiempos.vue?vue&type=script&lang=js&"
export * from "./SkuTiempos.vue?vue&type=script&lang=js&"
import style0 from "./SkuTiempos.vue?vue&type=style&index=0&id=47494ea4&prod&lang=scss&scoped=true&"
import style1 from "./SkuTiempos.vue?vue&type=style&index=1&id=47494ea4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47494ea4",
  null
  
)

export default component.exports